<template>
  <div class="tab-list">
    <div class="list">
      <div :class="['tab-item', {'select-item': item.select, 'act': i === act}]"
           @click="handleClick(item, i)"
           v-for="(item, i) in list"
           :key="i">
        <span v-if="!item.select || item.select && act !== i">
          {{ item.label }}
        </span>
        <element-select @click="clickSelect(item, i)"
                        :val="item.selectId"
                        v-model="item.selectId"
                        :options="item.options"
                        @val="changeSelectVal($event, item, i)"
                        v-else />
      </div>
    </div>
  </div>
</template>

<script>
  import ElementSelect from "./element-select";
  export default {
    name: "tabList",
    components: {ElementSelect},
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      act: {
        type: Number,
        default: null
      }
    },
    data() {
      return {}
    },
    methods: {
      handleClick(item, i) {
        this.$emit('clickItem', item, i)
      },
      clickSelect(item, i) {
        this.$emit('clickItem', item, i)
      },
      changeSelectVal(val, item, i) {
        this.$emit('changeSelect', item, i)
      }
    }
  }
</script>

<style lang="less" scoped>
  .tab-list {
    height: 28px;
    margin: 16px 0;

    .list {
      box-shadow: 0 0 10px 1px rgba(0, 197, 250, 0.5) inset;
      background: linear-gradient(0deg, rgba(0, 197, 250, 0.5) 0%, rgba(0, 197, 250, 0.20) 6%, rgba(0, 197, 250, 0.20) 93%, rgba(0, 197, 250, 0.50) 100%);
      /*background: linear-gradient(0deg, rgba(0, 197, 250, 0.5) 0%, rgba(0, 197, 250, 0.46) 6%, rgba(0, 197, 250, 0.44) 93%, rgba(0, 197, 250, 0.50) 100%);*/
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: absolute;
      right: 10px;
    }

    .tab-item {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      padding: 0 15px;
      min-width: 88px;
      .flex-center();
      justify-content: center;
      cursor: pointer;
      word-break: keep-all;

      &:nth-child(n+2):not(.act) {
        position: relative;
        &:before {
          content: '';
          width: 1px;
          height: 16px;
          background: #11B8E5;
          opacity: 0.5;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      &.select-item.act {
        padding: 0 6px;
      }

      &.act {
        height: 28px;
        box-shadow: 0 0 10px 1px rgba(0, 197, 250, 0.5) inset;
        background: linear-gradient(0deg, rgba(0, 197, 250, 0.50) 0%, rgba(0, 197, 250, 0.26) 6%, rgba(0, 197, 250, 0.24) 93%, rgba(0, 197, 250, 0.50) 100%);
        border-radius: 3px;

        +.tab-item {
          &::before {
            width: 0;
          }
        }

        /deep/.el-select {
          /*width: 100%;*/

          .el-input,
          input {
            background: transparent;
          }
        }
      }
    }
  }
</style>